<div data-test="_4S27okW" class="form-group">
  <div data-test="7-7zxcTR" class="form-group__label">{{ label }}</div>
  <div data-test="sJ2Iwo_J" class="form-group__field">
    <ng-content></ng-content>
    <label data-test="6oursZxt" class="form-group__field-append link-light" for="input-2">
      <i data-test="Sodag1BB" class="material-icons md-16">keyboard_arrow_down</i>
    </label>
    <div data-test="1GD54qcA" class="dropdown pt-0 w-100" id="">
      <div data-test="DOqCJmwW" class="dropdown__wrap">
        <ul data-test="qRiSN1_3" class="dropdown__menu">
          <li
            data-test="61T40MLi"
            (mousedown)="handleClick(item)"
            *ngFor="let item of items"
            class="dropdown__menu-item"
            [class.checked]="
              (item.uuid &&
                currentItem?.uuid &&
                item.uuid === currentItem?.uuid?.value) ||
              item === currentItem
            "
          >
            <a data-test="b8rMlym1" class="dropdown__menu-link">
              {{ item?.name || item }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
